/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import LoadingModal from "components/LoadingModel/loadingModal";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSuperAdminDasboardActivityData } from "utils/superAdminApi";

function OrdersOverview() {

  const [loading, setLoading] = useState(false);
  const [trialUserDate, setTrialUserDate] = useState(null);
  const [boughtSubscriptionDate, setBoughtSubscriptionDate] = useState(null);
  const [lastAdditionalCreditDate, setLastAdditionalCreditDate] = useState(null);
  const [highestCreditUsageUsername, setHighestCreditUsageUsername] = useState(null);
  const [highestCreditUsageAmount, setHighestCreditUsageAmount] = useState(0);
  const [lowestCreditUsageUsername, setLowestCreditUsageUsername] = useState(null);
  const [lowestCreditUsageAmount, setLowestCreditUsageAmount] = useState(0);
  const [cancellationRequest, setCancellationDate] = useState(null);
  const dispatch = useDispatch()

  useEffect(() => {
    fetchSuperAdminDasboardActivityData();
  }, []);

  const fetchSuperAdminDasboardActivityData = async () => {
    getSuperAdminDasboardActivityData((data) => {
      let resData = data.output;
      if (resData && resData.formattedTrialUserDate.length > 0) {
        setTrialUserDate(resData.formattedTrialUserDate[0].trialUserDate)
      }
      if (resData && resData.formattedBoughtSubscriptionDate.length > 0) {
        setBoughtSubscriptionDate(resData.formattedBoughtSubscriptionDate[0].boughtSubscriptionDate)
      }
      if (resData && resData.formattedAdditionalCreditsDate.length > 0) {
        setLastAdditionalCreditDate(resData.formattedAdditionalCreditsDate[0].lastAdditionalCreditDate);
      }
      if (resData && resData.highestCreditUsage.length > 0) {
        setHighestCreditUsageUsername(resData.highestCreditUsage[0].userName);
        setHighestCreditUsageAmount(resData.highestCreditUsage[0].totalCreditsUsed);
      }
      if (resData && resData.lowestCreditUsage.length > 0) {
        setLowestCreditUsageUsername(resData.lowestCreditUsage[0].userName);
        setLowestCreditUsageAmount(resData.lowestCreditUsage[0].totalCreditsUsed);
      }
      if (resData && resData.cancellationFormatedDate.length > 0) {
        setCancellationDate(resData.cancellationFormatedDate[0].cancellationDate)
      }
    }, dispatch)
  }

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Business User Activities
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <TimelineItem
          color="success"
          icon="person"
          title="Last Trial User Signed"
          dateTime={trialUserDate}
        />
        <TimelineItem
          color="error"
          icon="inventory_2"
          title="Last Subscription Purchased"
          dateTime={boughtSubscriptionDate}
        />
        <TimelineItem
          color="info"
          icon="shopping_cart"
          title="Last Additional Credits Purchased"
          dateTime={lastAdditionalCreditDate}
        />
        <TimelineItem
          color="warning"
          icon="payment"
          title="Last Subscription Cancelled"
          dateTime={cancellationRequest}
        />
        <TimelineItem
          color="primary"
          icon="vpn_key"
          title="Highest Credit Usage"
          dateTime={highestCreditUsageUsername + " (" + highestCreditUsageAmount + ")"}
        />
        <TimelineItem
          color="primary"
          icon="vpn_key"
          title="Lowest Credit Usage"
          dateTime={lowestCreditUsageUsername + " (" + lowestCreditUsageAmount + ")"}
          lastItem
        />
      </MDBox>
      <LoadingModal loading={loading} />
    </Card>
  );
}

export default OrdersOverview;
